var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',[_vm._v(_vm._s(_vm.params.data.student.name))]),_c('span',[_vm._v(" ")]),_c('span',[_vm._v(_vm._s(_vm.params.data.student.last_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }